import { getUserId } from '../utils/logging';

const storeUserId = userId => ({
  type: 'STORE_USER_ID',
  userId
});

export const initializeUser = () => dispatch => {
  getUserId().then(userId => {
    return dispatch(storeUserId(userId));
  });
};

const initialState = {
  userId: null
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case 'STORE_USER_ID': {
      return {
        ...state,
        userId: action.userId
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ../core/src/store/user.js